import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ToastContainer } from 'react-toastify'
// import 'bootstrap/dist/css/bootstrap.min.css';

// Silence debug console.log in production so API responses / user data are not
// printed to the browser console on the live site. Real errors/warnings still
// show (console.error / console.warn are left intact).
if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  //  <React.StrictMode>
   <>
    <App />
    <ToastContainer/>
    </>
  // </React.StrictMode> 
)

reportWebVitals();
